<template>
  <el-select v-model="templateId"
    style="vertical-align: top;"
    placeholder="请选择H5模板">
    <el-option v-for="item in list"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
</template>
<script>
export default {
  name: 'wap-template-select',
  props: {
    value: { required: true },
    tradeType: { type: Number, default: 1 }
  },
  data () {
    return {
      list: []
    }
  },
  computed: {
    templateId: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    fetchList () {
      this.$$CommonApi.geth5templates({ tradeType: this.tradeType })
        .then(res => {
          const { result, message, enums } = res.data
          if ([0, 13].includes(result)) {
            this.list = enums
          } else {
            this.$message.error(message)
            this.list = []
          }
        })
        .catch(err => {
          this.list = []
          console.log(err)
        })
    }
  },
  mounted () {
    this.fetchList()
  }
}
</script>
